import { render, staticRenderFns } from "./ToggleGroup.vue?vue&type=template&id=4fd5243d&scoped=true"
import script from "./ToggleGroup.vue?vue&type=script&lang=js"
export * from "./ToggleGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd5243d",
  null
  
)

export default component.exports